export const cardMeening = {
    yes: 2,
    maybe: 3,
    no: 1
}